import React from 'react';
function Analytics({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M18.9 13a.1.1 0 01.1.1A8 8 0 1110.9 5c.055 0 .1.045.1.1v7.8a.1.1 0 00.1.1h7.8z" />
      <path d="M16.987 3.495A6.5 6.5 0 0014.6 3c-.055-.001-.1.044-.1.099v6.3a.1.1 0 00.1.1h6.3c.055 0 .1-.045.1-.1a6.5 6.5 0 00-4.013-5.905zM17.942 16.976a8 8 0 001.057-3.876.1.1 0 00-.099-.1h-7.725a.1.1 0 00-.087.15l3.909 6.664c.027.048.089.064.136.036a8 8 0 002.809-2.874z" />
    </svg>
  );
}

export default Analytics;
